import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandingHeader from './components/BrandingHeader';
import WelcomeMessage from './components/WelcomeMessage';
import LoginForm from './components/LoginForm';
import SecurityBadge from './components/SecurityBadge';

const AdminLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      navigate('/admin-dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-2xl shadow-lg p-8">
          <BrandingHeader />
          <WelcomeMessage />
          <LoginForm />
          <SecurityBadge />
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-text-secondary">
            &copy; {new Date()?.getFullYear()} EpoxyViz Pro. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;